import request from "./axios";

function index(params) {
  return request({
    method: "get",
    url: `/deals`,
    params: params
  })
}

function get(id) {
  return request({
    method: "get",
    url: `/deals/${id}`,
  })
}

function takeAction(action, id, params) {
  return request({
    method: "post",
    url: `/deals/${id}/action/${action}`,
    data: { deal_action: params }
  })
}

function sendGroupMessage(params) {
  return request({
    method: "post",
    url: `/deals/send_group_message`,
    data: params
  })
}

function sendBulkMessage(params) {
  return request({
    method: "post",
    url: `/deals/send_bulk_message`,
    data: params
  });
}

function groupAction(action, params) {
  return request({
    method: "post",
    url: `/deals/group_action/${action}`,
    data: params
  })
}

function stats() {
  return request({
    method: "get",
    url: `/deals/stats`
  })
}

function removeContact(deal_id, contact_id) {
  return request({
    method: "patch",
    url: `/deals/${deal_id}/remove_contact`,
    data: { contact_id: contact_id }
  })
}

function getDealsForDate(params) {
  return request({
    method: "get",
    url: `/deals/get_deals_for_date`,
    params: params
  });
}

const DealsService = {
  index,
  get,
  takeAction,
  sendGroupMessage,
  groupAction,
  stats,
  removeContact,
  sendBulkMessage,
  getDealsForDate
};

export default DealsService;
